module.exports = __webpack_public_path__ + "img/planner.41f63dc0.png";